import { createContext } from 'react';

import { PageContent } from '../@types/content/page';

const LanguageContext = createContext({
  lang: 'en-gb',
} as PageContent.LanguageType);

export default LanguageContext;
